"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _colors = require("../../style/colors");
var _excluded = ["children", "classes", "className", "colorScheme", "fixedPosition", "invertScheme", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      padding: '1rem',
      zIndex: theme.zIndex.nav
    },
    fixedPosition: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      padding: '.5rem 2.75rem'
    }, theme.breakpoints.gt.mobile.portrait, {
      padding: '.5rem 3rem'
    }), theme.breakpoints.gt.tablet.portrait, {
      padding: '1rem 4.875rem'
    }), "top", theme.functions.toRem(theme.variables.navHeight)), "left", 0), "position", 'fixed'), "width", '100%'),
    clearFix: {
      height: theme.functions.toRem(theme.variables.navHeight)
    },
    colorScheme: theme.mixins.colorScheme,
    invertScheme: theme.mixins.invertScheme,
    bannerContents: _objectSpread(_objectSpread({
      color: theme.colors.black
    }, theme.typography.extraSmallText), {}, (0, _defineProperty2.default)({}, theme.breakpoints.gt.mobile.portrait, _objectSpread({}, theme.typography.header5)))
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children: Node,
  colorScheme: string,
  fixedPosition: boolean,
  invertScheme?: boolean
};*/
var Banner = function Banner(_ref /*:: */) {
  var children = _ref /*:: */.children,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    colorScheme = _ref /*:: */.colorScheme,
    fixedPosition = _ref /*:: */.fixedPosition,
    invertScheme = _ref /*:: */.invertScheme,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, invertScheme ? classes.invertScheme : classes.colorScheme, true), classes.fixedPosition, fixedPosition), className),
    "data-color": colorScheme
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bannerContents
  }, children)), fixedPosition && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.clearFix
  }));
};
Banner.defaultProps = {
  colorScheme: _colors.CANARY,
  fixedPosition: false
};
Banner.displayName = 'Banner';
var _default = exports.default = (0, _injectSheet.default)(Style)(Banner);
//# sourceMappingURL=Banner.js.map